<template>
  <div class="pt-4 pb-5 px-5">
    <div>
      <h5 id="scroll-description" class="font-size-21 font-weight-bold text-dark mb-4">
        {{'Room'}} {{pax.displayRoomNum}} :
        {{pax.paxType=="ADT"?$t('passInfo.adult'):pax.paxType=="CHD"?$t('passInfo.child')
        :pax.paxType=="INF"?$t('passInfo.infant'):null}}{{' '+pax.displayPaxNum}}
      </h5>
    </div>
    <div >
      <!-- class="individual-info border-none" -->
      <div>
        <div class="row" >
          <!-- class="custom-row-pass position-relative" -->
          <CCol
            
            v-if="rule.paxTitleCtrl && rule.paxTitleCtrl.isVisible"
          >
          <!-- class="custom-input-pass-multi name-title" -->
            <cDropDown
              :isDisable="rule.paxTitleCtrl && rule.paxTitleCtrl.isDisable"
              :label="'Title'"
              :ctrlName="'name'"
              :ctrlCode="'code'"
              :isShowCode="true"
              :isMultiple="false"
              :isSearchable="false"
              v-on:input="onTitleChange"
              :paxType="pax.paxType"
              :url="getPaxTitleURL()"
              :selValue="pax.paxTitle"
              :rules="rule.paxTitleRules"
            />
          </CCol>

          <CCol v-if="rule.fNameCtrl.isVisible" >
         <!-- class="custom-input-pass fname" -->
            <ValidationProvider
              :rules="rule.fNameRules"
              :name="$t('passInfo.fName')+paxIndex"
              v-slot="{ errors }"
            >
              <label>{{$t('passInfo.fName')}}</label>
              <input
                :id="'fName'+paxIndex"
                :name="$t('passInfo.fName')+paxIndex"
                class="form-control uppercase"
                v-model="pax.fName"
                type="text"
                :placeholder="$t('passInfo.frstPl')"
                :disabled="rule.fNameCtrl.isDisable"
                v-on:change="onAssignFNameToContact(pax.fName)"
              />
              <div
                v-if="errors && errors[0]"
                class="invalid-feedback d-block icon"
                v-getError="emitError(paxIndex)"
              >
                <span>{{errors[0] | errmsg(paxIndex) }}</span>
              </div>
              <div
                v-if="pax.isSameName"
                class="invalid-feedback d-block icon"
              >{{$t('passInfo.sameName')}}</div>
            </ValidationProvider>
          </CCol>
          <CCol v-if="rule.lNameCtrl.isVisible" >
            <!-- class="custom-input-pass lname" -->
            <ValidationProvider
              :rules="rule.lNameRules"
              :name="$t('passInfo.lName')+paxIndex"
              v-slot="{ errors }"
            >
              <label>{{$t('passInfo.lName')}}</label>
       
              <input
                :id="'lName'+paxIndex"
                class="form-control uppercase"
                v-model="pax.lName"
                :placeholder="$t('passInfo.lastPl')"
                type="text"
                :disabled="rule.lNameCtrl && rule.lNameCtrl.isDisable"
              />
              <div
                v-if=" errors && errors[0]"
                class="invalid-feedback d-block icon"
                v-getLnameError="emitError(paxIndex)"
              >
                <span>{{errors[0] | errmsg(paxIndex)}}</span>
              </div>
            </ValidationProvider>
          </CCol>
          <div>
             <!-- class="help pt-16px" -->
            <img src="@imgPath/img/svg/icons/question_mark_circle.svg" alt width="20px" />
        
          </div>
          <div class="help-pass-content">
            <div class="wrapper">
              <div class="card-title">{{$t('cPax.paxInfoCardTitle')}}</div>
              <div class="sub-content">{{$t('cPax.paxInfoNameDesc')}}</div>
              <div class="card">
                <div class="top">
                  <div class="img">
                    <img src="@imgPath/img/svg/icons/user.svg" alt />
                  </div>
                  <div class="content">
                    <div class="wrap">
                      <div class="sub-title">{{$t('cPax.paxInfoNameTitle')}}</div>
                      <div class="sub-con">{{$t('cPax.paxInfoExName')}}</div>
                    </div>
                    <div class="wrap">
                      <div class="sub-title">{{$t('cPax.paxInfoExLNameTitle')}}</div>
                      <div class="sub-con">{{$t('cPax.paxInfoExLName')}}</div>
                    </div>
                    <div class="wrap">
                      <div class="bar"></div>
                    </div>
                  </div>
                </div>
                <div class="bottom">
                  <div class="left-ta">
                    <span>{{$t('cPax.paxInfoPassNum')}}</span>
                    <span>{{$t('cPax.paxInfoPassNum')}}</span>
                    <span>{{$t('cPax.paxInfoPassNum')}}</span>
                  </div>
                  <div class="right-ta">{{$t('cPax.passport')}}</div>
                </div>
              </div>
              <div class="bottom-dis-content">{{$t('cPax.paxInfoDesc')}}</div>
            </div>
          </div>
        </div >

        <div class="row">
           <!-- class="custom-row-pass" -->
          <CCol
            md="4"
            sm="6"
            xs="12"
            v-if="rule.nationalityCtrl && rule.nationalityCtrl.isVisible"
           
          >
           <!-- class="custom-input-pass-multi" -->
            <cDropDown
              :isDisable="citizen.country == defaultCountryValue"
              key="country"
              :label="$t('passInfo.nation')"
              :ctrlName="'value'"
              :ctrlCode="'countrycode'"
              :isShowCode="true"
              :isMultiple="false"
              :isSearchable="true"
              :url="getCountryServiceURL()"
              :rules="rule.nationalityRules"
              v-on:input="onCountryChange"
              :selValue="pax.nationality"
              :resultEmpty="$t('passInfo.countryResultEmpty')"
            />
          </CCol>

          <CCol
            md="4"
            sm="6"
            xs="12"
            v-if="rule.genderCtrl && rule.genderCtrl.isVisible"
         
          >
             <!-- class="custom-input-pass-radio" -->
            <div>
              <label>{{$t('passInfo.gender')}}</label>
            </div>

            <ValidationProvider
              :rules="rule.genderRules"
              :name="$t('passInfo.gender')+paxIndex"
              v-slot="{ errors }"
            >
              <div :disabled="rule.genderCtrl.isDisable" class="radio-wrap">
                <div
                  class="form-row form-inline c-pointer"
                  v-for="genders in genderList "
                  :key="genders.code"
                >
                  <div
                    @click="onGenderChange(genders)"
                    role="group"
                    class="custom-control custom-radio"
                  >
                    <input
                      :id="genders.code+paxIndex"
                      type="radio"
                      :value="genders"
                      v-model="pax.gender"
                      class="custom-control-input"
                    />
                    <label :for="genders.code+paxIndex" class="custom-control-label"></label>
                  </div>

                 
                  <label :for="genders.code+paxIndex">{{genders.name}}</label>
                </div>
              </div>
              <div v-if=" errors && errors[0]" class="invalid-feedback d-block icon">
                <span>{{errors[0] | errmsg(paxIndex)}}</span>
              </div>
            </ValidationProvider>
          </CCol>

          <CCol
            md="4"
            sm="12"
            xs="12"
            v-if="rule.dobCtrl && rule.dobCtrl.isVisible"
           
          >
           <!-- class="custom-input-pass" -->
            <ValidationProvider
              class="text-transform-unset"
              :rules="rule.dobMandateRule"
              :name="$t('passInfo.dob')+paxIndex"
            >
              <label :id="'dob'+paxIndex">{{$t('passInfo.dob')}}</label>
              <br />

              <div class="date-mod-label">
                <label :id="'dob'+paxIndex" class="date-label" :class="{'show' : isShowDob}">
                  <div v-if="selectedDob">{{ selectedDob | formatDate}}</div>
                  <div v-else class="place">DD-MMM-YYYY</div>
                </label>
                <datetime
                  :input-id="'dob'+paxIndex"
                  :flow="flow"
                  :format="DATE_TIME_FORMAT.DATE_PICKER_FORMAT"
                  :hidden-name="'DOB'"
                  :min-datetime="new Date(dobMaxLimit).toISOString()"
                  :max-datetime="new Date().toISOString()"
                  auto
                  :placeholder="$t('passInfo.dobPl')"
                  @close="getSelDate(true)"
                  @input="getPaxDob"
                  :value="pax.dob"
                ></datetime>
              </div>

              <div
                v-if="paxSubmit && rule.dobMandateRule.required && selectedDob==null"
                class="invalid-feedback d-block icon"
              >
                <span>{{$t('passInfo.mandatory')}}</span>
              </div>
              <CAlert v-if="pax.validDob!=null" show color="danger">{{pax.validDob}}</CAlert>
            </ValidationProvider>
          </CCol>
        </div >

        <div class="row" >
          <!-- class="custom-row-pass mob-mt-30px" -->
          <CCol
            md="4"
            sm="6"
            xs="12"
            v-if="rule.idTypeCtrl && rule.idTypeCtrl.isVisible"
           
          >
           <!-- class="custom-input-pass-multi" -->
            <cDropDown
              :isDisable="rule.idTypeCtrl && rule.idTypeCtrl.isDisable"
              :label="$t('passInfo.idType')"
              :ctrlName="'name'"
              :ctrlCode="'code'"
              :isShowCode="true"
              :isMultiple="false"
              :isSearchable="true"
              v-on:input="onIdTypeChange"
              :url="getIdTypeURL()"
              :selValue="pax.idType"
              :rules="rule.idTypeRules"
              :resultEmpty="$t('passInfo.idTypeResultEmpty')"
            />
          </CCol>

          <CCol
            md="4"
            sm="6"
            xs="12"
            v-if="rule.idNoCtrl && rule.idNoCtrl.isVisible"
           
          >
           <!-- class="custom-input-pass" -->
            <ValidationProvider
              :rules="getRules()"
              :name="pax.idType.name==$t('paxId.NRIC')?'NRC'+paxIndex:'Passport'+paxIndex"
              v-slot="{ errors }"
            >
              <label>{{$t('passInfo.idNo')}}</label>
              <input
                :id="'idNo'+paxIndex"
                @input="onIdNoChange"
                class="form-control uppercase"
                v-model="pax.idNo"
                type="text"
                :placeholder="$t('passInfo.idNPl')"
                :disabled="rule.idNoCtrl.isDisable"
              />

              <div
                v-if=" errors && errors[0]"
                class="invalid-feedback d-block icon"
                v-getidNoError="emitError(paxIndex)"
              >
                <span
                  v-if="errors[0].includes('field format')"
                >{{$t('passInfo.enterValid')}} {{pax.idType.name==$t('paxId.NRIC')?'NRC'+paxIndex:'Passport' | errmsg(paxIndex)}}</span>
                <span v-else>{{errors[0] | errmsg(paxIndex)}}</span>
              </div>

              <div
                v-else-if="paxSubmit &&  (pax.idNo=='' || pax.idNo==null) && selectedExpryDate"
                class="invalid-feedback d-block icon"
              >
                <span>{{$t('passInfo.mandatory')}}</span>
              </div>
              <div
                v-if="pax.isSameId"
                class="invalid-feedback d-block icon"
              >{{$t('passInfo.sameId')}}</div>
            </ValidationProvider>
          </CCol>
          <CCol
            md="4"
            sm="6"
            xs="12"
            v-if="pax.idType && pax.idType.code == 'PP'"
            
          >
          <!-- class="custom-input-pass" -->
            <ValidationProvider
              :rules="rule.expryDateMandatoryRule"
              :name="$t('passInfo.expryDate')+paxIndex"
            >
              <label :id="'pp'+paxIndex">{{$t('passInfo.expryDate')}}</label>
              <br />

              <div class="date-mod-label">
                <label :id="'pp'+paxIndex" class="date-label" :class="{'show' : isShowExpryDate}">
                  <div v-if="selectedExpryDate">{{ selectedExpryDate | formatDate}}</div>
                  <div v-else class="place">DD-MMM-YYYY</div>
                </label>

                <datetime
                  :input-id="'pp'+paxIndex"
                  :format="DATE_TIME_FORMAT.DATE_PICKER_FORMAT"
                  auto
                  :min-datetime="new Date().toISOString()"
                  :max-datetime="new Date(ppExpryMaxLimit).toISOString()"
                  :flow="flow"
                  placeholder="Expiry Date"
                  @close="getSelDate(false)"
                  @input="getPaxExpiryDate"
                  :value="pax.expiryDate"
                ></datetime>
              </div>

              <div
                v-if="paxSubmit && rule.expryDateMandatoryRule.required && selectedExpryDate==null"
                class="invalid-feedback d-block icon"
              >
                <span>{{$t('passInfo.mandatory')}}</span>
              </div>
              <div
                v-else-if="paxSubmit &&  pax.idNo!=null && !selectedExpryDate"
                class="invalid-feedback d-block icon"
              >
                <span>{{$t('passInfo.mandatory')}}</span>
              </div>
              <CAlert v-if="pax.validExpDate!=null" show color="danger">{{pax.validExpDate}}</CAlert>
            </ValidationProvider>
          </CCol>
        </div >
        <br>
        <div class="row"  >
         <!-- class="custom-row-pass mob-mt-30px" -->
          <div class="m-pass-message">
            <ul>
              <li>{{$t('passInfo.idInfo')}}</li>
            </ul>
          </div>
        </div >
      </div>
    </div>
  </div>
</template>


<script>
import {
  PAX,
  PAX_TITLE,
  ID_TYPE,
  CITIZEN
} from "../../../../util/constants.js";

import { Datetime } from "vue-datetime";

import cSearchPax from "../../../pax/cSearchPax";
import Logger from "../../../../services/logger";
import BaseConfiguration from "../../../../config/base";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../util/apiValidate.js";
import { ValidationObserver } from "vee-validate";
import { ValidationProvider, localize } from "vee-validate";
import SERVICE_URL from "../../../../config/API_DATA";
import cDropDown from "../../../../components/form/cDropDown";
import { mapGetters, mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";

import { COMPONENT_NAME, DATE_TIME_FORMAT } from "../../../../util/constants";
import apiGetCountryList from "../../../../services/apiGetCountryList.js";
import {
  addYears,
  subYears,
  isValidDob,
  isValidExpiryDate,
  withOutTime
} from "../../../../util/date/dateFunctions";


export default {
  name: COMPONENT_NAME.C_PAX,
  props: {
    paxSubmit: {
      type: Boolean,
      default: false
    },
    paxIndex: {
      type: Number,
      default: 0
    },

    citizen: {
      type: Object,
      default: null
    },
    pax: {
      type: Object,
      default: null
    },
    rule: {
      type: Object,
      default: null
    }
  },
  components: {
    cDropDown,
    Datetime,
    cSearchPax,

    ValidationObserver,
    ValidationProvider

  },
  computed: {
    DATE_TIME_FORMAT() {
      return DATE_TIME_FORMAT;
    },
    ...mapGetters("sPaxPage", {
      spaxObj: "GET_PAX_LIST"
    }),
    ...mapGetters("sCountryList", {
      countryResponse: "GET_COUNTRY_RES"
    })
  },

  data: () => ({
    defaultCountryValue: BaseConfiguration.defaultCountryValue,
    genderList: [
      {
        code: "M",
        name: "Male"
      },
      {
        code: "F",
        name: "Female"
      }
    ],
    flow: ["year", "month", "date"],
    dobMaxLimit: new Date(subYears(new Date(), BaseConfiguration.maxDOBYears)),
    ppExpryMaxLimit: new Date(
      addYears(new Date(), BaseConfiguration.maxPPExpryYears)
    ),

    selectedDob: null,
    selectedExpryDate: null,
    isShowDob: false,
    isShowExpryDate: false


  }),

  created() {
    if (this.pax) {
      if (this.paxIndex == 0) {
        this.pax.isLeadPax = true;
      } else {
        this.pax.isLeadPax = false;
      }
    }

    if (this.spaxObj == null) {
      if (this.citizen) {
        if (this.citizen.country == CITIZEN.MYANMAR.code) {
          this.pax.idType = { name: this.$t("paxId.NRIC"), code: ID_TYPE.NRIC };
        } else {
          this.pax.idType = {
            name: this.$t("paxId.PASSPORT"),
            code: ID_TYPE.PASSPORT
          };
        }
      }
    }

    /// to get dob from store
    if (this.spaxObj != null) {
      for (let index = 0; index < this.spaxObj.length; index++) {
        this.spaxObj[index].isSameId = false;
        this.spaxObj[index].isSameName = false;

        if (this.spaxObj[index] == this.pax) {
          if (this.spaxObj[index].dob != null) {
            this.selectedDob = this.spaxObj[index].dob;
          } else {
            this.pax.dob = this.getDefaultDob(this.pax.paxType);
          }
          if (this.spaxObj[index].expiryDate != null) {
            this.selectedExpryDate = this.spaxObj[index].expiryDate;
          } else {
            this.pax.expiryDate = this.getDefaultExpiryDate();
          }
        }
      }

      if (this.citizen && this.pax.idType && this.pax.idType.code == null) {
        if (this.citizen.country == CITIZEN.MYANMAR.code) {
          this.pax.idType = { name: this.$t("paxId.NRIC"), code: ID_TYPE.NRIC };
        } else {
          this.pax.idType = {
            name: this.$t("paxId.PASSPORT"),
            code: ID_TYPE.PASSPORT
          };
        }
      }

      //     }
    }
    if (this.pax && this.pax.paxTitle) {
      this.pax.gender = this.changeGenderByTitle(this.pax.paxTitle);
    }
    this.$on("emitError", this.emitError /*the name of the method to call */);
  },

  directives: {
    getError: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    },
    getLnameError: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    },
    getidNoError: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },

  methods: {
    getPaxExpiryDate(pDob) {
      try {
        if (BaseConfiguration.isDebug) console.log("getPaxExpiryDate");
        if (pDob && pDob.constructor != Event) {
          this.pax.expiryDate = pDob;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in getPaxExpiryDate",
          err.toString(),
          "getPaxExpiryDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getPaxDob(pDob) {
      try {
        if (BaseConfiguration.isDebug) console.log("getPaxDob");
        if (pDob && pDob.constructor != Event) {
          this.pax.dob = pDob;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in getPaxDob",
          err.toString(),
          "getPaxDob",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // getTitle(title){
    //   this.selectedTitle=title
    //   this.$emit("input",title)
    // },
    emitError(paxIndex) {
      this.$emit("caughtError", paxIndex);
    },

    getDefaultExpiryDate() {
      let expryDate = addYears(new Date(), 1);
      expryDate = expryDate.toISOString();
      return expryDate;
    },

    getDefaultDob(paxType) {
      let dob;

      if (paxType) {
        if (paxType == PAX.ADULT) {
          dob = subYears(new Date(), 40);
        }
        if (paxType == PAX.CHILDREN) {
          dob = subYears(new Date(), 12);
        }
        if (paxType == PAX.INFANT) {
          dob = subYears(new Date(), 2);
        }
      }
      dob = dob.toISOString();
      return dob;
    },

    getPaxDetails(paxDetails) {
      try {
        if (BaseConfiguration.isDebug) console.log("getPaxDetails");
        if (paxDetails) {
          let paxTypeTilte;
          this.pax.paxType = paxDetails.paxtype;

          this.pax.fName = paxDetails.firstname;

          if (paxDetails.isleadpax) {
            this.onAssignFNameToContact(paxDetails.firstname);
            this.assignMailFromRes(
              paxDetails.paxemail,
              paxDetails.mobile_number
            );
          }
          this.pax.lName = paxDetails.lastname;

          //   this.selectedDob=this.$options.filters.formatDate(
          //        paxDetails.paxdob,

          //       );
          this.selectedDob = paxDetails.paxdob;
          this.pax.validDob = this.isValidDob(paxDetails.paxdob);
          if (this.pax.validDob == null) {
            this.$emit("getDob", paxDetails.paxdob, this.paxIndex);
          } else {
            this.$emit("getDob", null, this.paxIndex);
          }

          this.onIdTypeChange(paxDetails.doctype);
          //   this.selectedExpryDate=this.$options.filters.formatDate(
          //        paxDetails.docexpiry,

          //       );
          this.selectedExpryDate = paxDetails.docexpiry;
          this.pax.validExpDate = this.isValidExpDate(paxDetails.docexpiry);
          if (this.pax.validExpDate == null) {
            this.$emit("getSelExpryDate", paxDetails.docexpiry, this.paxIndex);
          } else {
            this.$emit("getSelExpryDate", null, this.paxIndex);
          }
          this.pax.idNo = paxDetails.docnumber;
          this.onCountryChange(paxDetails.nationality);
          //   this.pax.nationality=paxDetails.nationality;
          let pTitle = {
            name: null,
            code: null
          };

          pTitle.name = paxDetails.title;
          pTitle.code = paxDetails.title;
          //  this.onTitleChange(pTitle);
          if (this.pax.paxType == "ADT") {
            paxTypeTilte = PAX_TITLE.ADT;
          } else if (this.pax.paxType == "CHD") {
            paxTypeTilte = PAX_TITLE.CHD;
          } else if (this.pax.paxType == "INF") {
            paxTypeTilte = PAX_TITLE.INF;
          }
          for (var j in paxTypeTilte) {
            if (paxTypeTilte[j].includes(pTitle.code)) {
              this.pax.paxTitle = pTitle;
            }
          }
          //   this.onGenderChange(paxDetails.gender);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in getPaxDetails",
          err.toString(),
          "getPaxDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assignMailFromRes(pemail, pmblNo) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assignMailFromRes");
        if (this.paxIndex == 0) {
          this.$emit("getMblEmailFromRes", pemail, pmblNo);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in assignMailFromRes",
          err.toString(),
          "assignMailFromRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    onGenderChange(pGender) {
      try {
        if (BaseConfiguration.isDebug) console.log("onGenderChange");
        if (pGender == 1) {
          this.pax.gender = this.genderList[0];
        } else if (pGender == 2) {
          this.pax.gender = this.genderList[1];
        } else {
          this.pax.gender = pGender;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in onGenderChange",
          err.toString(),
          "onGenderChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getCountryServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCountryServiceURL");
      return SERVICE_URL.GET_COUNTRY_LIST;
    },

    getPaxTitleURL() {
      if (BaseConfiguration.isDebug) console.log("getPaxTitleURL");
      return SERVICE_URL.PAX_TITLE;
    },

    getIdTypeURL() {
      if (BaseConfiguration.isDebug) console.log("getIdTypeURL");
      return SERVICE_URL.GET_ID_TYPE;
    },

    getSelDate(isDob) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelDate");
        //let retValue;
        if (isDob) {
          if (this.pax.dob) {
            this.selectedDob = new Date(this.pax.dob).toISOString();
            this.pax.validDob = this.isValidDob(this.selectedDob);
            if (this.pax.validDob == null) {
              this.$emit("getDob", this.selectedDob, this.paxIndex);
            } else {
              this.$emit("getDob", null, this.paxIndex);
            }
            this.isShowDob = true;
          }
        } else {
          if (this.pax.expiryDate) {
            this.selectedExpryDate = new Date(
              this.pax.expiryDate
            ).toISOString();
            this.pax.validExpDate = this.isValidExpDate(this.selectedExpryDate);
            if (this.pax.validExpDate == null) {
              this.$emit(
                "getSelExpryDate",
                this.selectedExpryDate,
                this.paxIndex
              );
            } else {
              this.$emit("getSelExpryDate", null, this.paxIndex);
            }
            this.isShowExpryDate = true;
          }
        }
        this.$emit("getIsDisable", false);
      } catch (err) {
        let body = Logger.buildRequest(
          "cPax",
          "error in getSelDate",
          err.toString(),
          "getSelDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      //return retValue;
    },

    isValidExpDate(pSelectedExpDate) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("isValidExpDate");
        if (this.pax.idType.code != ID_TYPE.NRIC) {
          if (pSelectedExpDate != null)
            if (
              isValidExpiryDate(
                new Date(this.rule.expryDateRules.max),
                new Date(pSelectedExpDate)
              )
            ) {
              retValue = null;
            } else {
              if (this.pax.fName != null) {
                retValue =
                  this.$t("passInfo.expryDate") +
                  " " +
                  this.$t("passInfo.of") +
                  " " +
                  this.pax.fName +
                  " " +
                  this.$t("passInfo.invalid");
              } else {
                retValue =
                  this.$t("passInfo.expryDate") +
                  " " +
                  this.$t("passInfo.invalid");
              }
            }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in isValidExpDate",
          err.toString(),
          "isValidExpDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    isValidDob(pSelectedDob) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("isValidDob");
        retValue = this.dobValidate(
          this.pax.paxType,
          pSelectedDob,
          this.pax.fName
        );
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in isValidDob",
          err.toString(),
          "isValidDob",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    dobValidate(pPaxType, pSelDate, pFName) {
      let retValue;

      let paxType =
        pPaxType == PAX.ADULT
          ? this.$t("passInfo.adult")
          : pPaxType == PAX.CHILDREN
          ? this.$t("passInfo.child")
          : this.$t("passInfo.infant");
      let nextPaxType =
        pPaxType == PAX.ADULT
          ? this.$t("passInfo.adult")
          : pPaxType == PAX.CHILDREN
          ? this.$t("passInfo.adult")
          : this.$t("passInfo.child");
      let paxAge =
        pPaxType == PAX.ADULT
          ? BaseConfiguration.dobValidation.adultMin
          : pPaxType == PAX.CHILDREN
          ? BaseConfiguration.dobValidation.childMin
          : BaseConfiguration.dobValidation.infantMin;
      try {
        if (pSelDate != null) {
          let depMin = withOutTime(new Date(this.rule.depDobRules.depMin));
          let depMax = withOutTime(new Date(this.rule.depDobRules.depMax));
          // let arrMin = withOutTime(new Date(this.rule.arrDobRules.arrMin));
          // let arrMax = withOutTime(new Date(this.rule.arrDobRules.arrMax));
          let selDate = withOutTime(new Date(pSelDate));

          if (isValidDob(depMin, depMax, selDate)) {
            // if(isValidDob(arrMin,arrMax,selDate))
            //             {
            //                 retValue = null;
            //             }
            //             else
            //             {
            //                 //  retValue = false;
            //                  retValue = this.$t('passInfo.arrDobInvalid',{pType:paxType, age:paxAge, nxtPType:nextPaxType})
            //     }
          } else {
            if (pFName != null) {
              retValue =
                this.$t("passInfo.depDobInvalid") +
                " " +
                this.$t("passInfo.of") +
                " " +
                pFName +
                " " +
                this.$t("passInfo.invalid");
            } else {
              retValue =
                this.$t("passInfo.depDobInvalid") +
                " " +
                this.$t("passInfo.invalid");
            }
          }
        } else {
          retValue = null;
          //  retValue = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          dobValidate,
          "error in dobValidate",
          err.toString(),
          "dobValidate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    onCountryChange(selCountryObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("onCountryChange");
        if (this.pax && this.pax.nationality && selCountryObj.countrycode) {
          this.pax.nationality = selCountryObj;

          if (this.paxIndex == 0) {
            this.$emit("getMblcode", selCountryObj);
          }
        } else if (this.countryResponse != null) {
          for (let i = 0; i < this.countryResponse.length; i++) {
            if (this.countryResponse[i].countrycode == selCountryObj) {
              retValue = this.countryResponse[i];
              this.pax.nationality = retValue;
              break;
            }
          }
          if (this.paxIndex == 0) {
            this.$emit("getMblcode", retValue);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          onCountryChange,
          "error in onCountryChange",
          err.toString(),
          "onCountryChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onIdTypeChange(selIdTypeObj) {
      // alert('Idtype');
      try {
        if (BaseConfiguration.isDebug) console.log("onIdTypeChange");
        if (selIdTypeObj == ID_TYPE.NRIC) {
          this.pax.idType = { name: this.$t("paxId.NRIC"), code: ID_TYPE.NRIC };
        } else if (selIdTypeObj == ID_TYPE.PASSPORT) {
          this.pax.idType = {
            name: this.$t("paxId.PASSPORT"),
            code: ID_TYPE.PASSPORT
          };
        } else if (this.pax && this.pax.idType) {
          this.pax.idType = selIdTypeObj;
          this.pax.idNo = null;
          this.selectedExpryDate = null;
          this.$emit("getSelExpryDate", this.selectedExpryDate, this.paxIndex);
        }
        // this.$emit('selIdType',this.pax.idType,this.rule,this.pax.paxType);
      } catch (err) {
        let body = Logger.buildRequest(
          onIdTypeChange,
          "error in onIdTypeChange",
          err.toString(),
          "onIdTypeChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onAssignFNameToContact(pFName) {
      try {
        if (BaseConfiguration.isDebug) console.log("onAssignFNameToContact");
        this.$emit("getContactName", pFName);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in onAssignFNameToContact",
          err.toString(),
          "onAssignFNameToContact",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    changeGenderByTitle(pSelTitleObj) {
      try {
        let retValue = null;
        if (BaseConfiguration.isDebug) console.log("changeGenderByTitle");

        if (pSelTitleObj.code == "Mr" || pSelTitleObj.code == "Master") {
          retValue = this.genderList[0];
        } else if (pSelTitleObj.code == "Mrs" || pSelTitleObj.code == "Miss") {
          retValue = this.genderList[1];
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_PAX,
          "error in changeGenderByTitle",
          err.toString(),
          "changeGenderByTitle",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onTitleChange(selTitleObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onTitleChange");

        if (this.pax) {
          this.pax.paxTitle = selTitleObj;
          let retGenderVal = this.changeGenderByTitle(selTitleObj);
          if (retGenderVal) {
            this.pax.gender = retGenderVal;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          onTitleChange,
          "error in onTitleChange",
          err.toString(),
          "onTitleChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onIdNoChange(e) {
      try {
        var start = e.target.selectionStart;
        this.pax.idNo = this.pax.idNo.toUpperCase();
        this.$nextTick(() => {
          e.target.selectionStart = e.target.selectionEnd = start;
        });

        this.$emit("getIsDisable", false);
      } catch (err) {
        let body = Logger.buildRequest(
          onIdNoChange,
          "error in onIdNoChange",
          err.toString(),
          "onIdNoChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getExpryDateVisibilty() {
      let retValue;
      try {
        if (this.pax.idType != null) {
          if (this.pax.idType.code == ID_TYPE.PASSPORT) {
            retValue = true;
          } else {
            retValue = false;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          getExpryDateVisibilty,
          "error in getExpryDateVisibilty",
          err.toString(),
          "getExpryDateVisibilty",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    //to get rules for the field
    getRules() {
      let retValue = {
        required: false
        // min: null,
        // max: null,
        // paxregex: null
      };

      try {
        if (this.rule.idNoCtrl.isVisible && this.rule.idNoCtrl.isMandatory) {
          retValue.required = true;
        }
        if (this.pax.idType != null) {
          if (this.pax.idType.code == ID_TYPE.PASSPORT) {
            retValue["min"] = this.rule.idNoRules.regex[0].pp.min;
            retValue["max"] = this.rule.idNoRules.regex[0].pp.max;
            retValue["paxregex"] = this.rule.idNoRules.regex[0].pp.regex;
          } else if (this.pax.idType.code == ID_TYPE.NRIC) {
            retValue["min"] = this.rule.idNoRules.regex[0].nric.min;
            // retValue.max = this.rule.idNoRules.regex[0].nric.max;
            retValue["paxregex"] = this.rule.idNoRules.regex[0].nric.regex;
          }
          // console.log(retValue);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          getRules,
          "error in getRules",
          err.toString(),
          "getRules",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // console.log(pName+' '+JSON.stringify(retValue));
      //   console.log(pName);
      return retValue;
    }
  }
};
</script>

<style scoped>
.uppercase {
  text-transform: uppercase;
}
/* .fname {
         text-transform: uppercase;
    } */
</style>
